@if ((nonEmpty && allLoaded && total) || (!nonEmpty && allLoaded)) {
<p
  class="loading-icon"
  data-e2e="pagination-done"
  i18n="
    PaginationLoader|Loader complete indicator text@@loaderCompleteIndicatorText"
>
  <fa-icon [icon]="['fas', 'circle-check']"></fa-icon>
  All products loaded
</p>
} @if (loading) {
<p
  class="loading-icon"
  i18n="PaginationLoader|Loading indicator text@@loadingIndicatorText"
  data-e2e="pagination-loader"
>
  <fa-icon [icon]="['fas', 'spinner']" [spin]="true" [pulse]="true"></fa-icon>
  Loading products
</p>
}
